export const SDK_VERSION = '8.26.0';
